<div class="container">
  <app-top-header></app-top-header>
   <div class="row">
   <div class="col-md-12 order-md-1">
      <count-days></count-days>
       <router-outlet></router-outlet>
    </div>
  </div>
    <footer class="my-5 pt-5 text-muted text-center text-small">
    <app-footer></app-footer>
  </footer>
</div>

    